const alertBioprocessDefaultState = {
    data: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const alertBioprocessReducer = (state = alertBioprocessDefaultState, action) => {
    switch(action.type) {
        case 'START_GET_ALERT_BIOPROCESS':
            return {
                ...state,
                data: {},
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ALERT_BIOPROCESS_SUCCESS':
            return {
                ...state,
                data: action.alertBioprocess,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_ALERT_BIOPROCESS_SUCCESS':
        return {
            data: action.alertBioprocess,
            loading: false,
            success: true,
            error: false,
            errorMessage: null,
            successMessage: 'Bioprocess Alert has been updated',
        };
        case 'START_ALERT_BIOPROCESS_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_ALERT_BIOPROCESS_SUCCESS':
            return {
                ...state,
                data: action.alertBioprocess,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Alert News has been updated',
            };
        case 'START_REMOVE_ALERT_BIOPROCESSS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_ALERT_BIOPROCESSS_SUCCESS':
            return {
                ...state,
                data: state.data.filter(ad => { // check original posts and only include posts that don't have that to delete ID
                    return !action.adIds.includes(ad.id); // includes is checking inside an array of numbers to see if any match
                }),
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your ads have been removed!',
            };
        case 'ALERT_BIOPROCESSS_CLEAR_SUCCESS':
            return {
                ...state,
                success: false
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default alertBioprocessReducer;